import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { BudgetActionCreateEditState, BudgetActionCreateEditReducer, ACTION_TYPES } from './budget-action-create-edit-reducer';
export { ACTION_TYPES };

const BudgetActionCreateEditContext = createContext<BudgetActionCreateEditState | undefined>(undefined);
const BudgetActionCreateEditDispatchContext = createContext({} as any);

export const BudgetActionCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { budgetActionId } = useParams();

    const initialState: BudgetActionCreateEditState = {
        budgetActionId,
        budgetActionRequest: {},
        selectedBudgetUnitId: undefined,
        budgetUnits: [],
        budgetPrograms: [],
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(BudgetActionCreateEditReducer, initialState);

    return (
        <BudgetActionCreateEditContext.Provider value={state}>
            <BudgetActionCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </BudgetActionCreateEditDispatchContext.Provider>
        </BudgetActionCreateEditContext.Provider>
    );
};

export const useBudgetActionCreateEditState = () => {
    const context = useContext(BudgetActionCreateEditContext);
    if (context === undefined) throw new Error('useBudgetActionCreateEditState must be used within BudgetActionCreateEditProvider');
    return context;
};

export const useBudgetActionCreateEditDispatch = () => {
    const context = useContext(BudgetActionCreateEditDispatchContext);
    if (context === undefined) throw new Error('useBudgetActionCreateEditDispatch must be used within BudgetActionCreateEditProvider');
    return context;
};
